// auth.service.ts
import { Injectable } from '@angular/core';
import { SessionService } from '@services/session.service';
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';

const authConfig: AuthConfig = {
 	loginUrl: "https://accounts.claveunica.gob.cl/openid/authorize/",
			tokenEndpoint: "https://accounts.claveunica.gob.cl/oauth2/token",
			userinfoEndpoint:
				"https://accounts.claveunica.gob.cl/openid/userinfo",
			clientId: "4a94478dd25f4430a0a023b87e11170d",
			redirectUri: "https://milicenciamedica.cl/",
			responseType: "code",
			scope: "openid run name",
			oidc: true,
			requestAccessToken: true,
  
};

@Injectable({ providedIn: 'root' })
export class AuthService {
  private stateKey = 'cu_state';
  isAuthenticated$: any;

  constructor(private oauth: OAuthService, private sessionService: SessionService) {
    this.oauth.configure(authConfig);
   
  }

  loginWithClaveUnica() {
    if (true) {
      this.oauth.initCodeFlow(environment.esiEnvironment);
      return;
    }
  }


  async handleCallback(url: string) {
    const params = new URL(url).searchParams;
    const code = params.get('code');
    const returnedState = params.get('state');

    const expectedState = sessionStorage.getItem(this.stateKey);
    console.log('Managing callback');
    if (!code || !returnedState || returnedState !== expectedState) {
      throw new Error('State inválido');
    }

    const res = await fetch('/api/auth/claveunica/callback', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ code }),
    });

    if (!res.ok) throw new Error('Error autenticando');

    const user = await res.json();
    return user;
  }

  logout() {
    this.sessionService.clearSesion();
    this.oauth.logOut();
  }

  get isLoggedIn$() {
    return this.sessionService.sesion$   
      .pipe(map(s => !!s));              
  }
}
